import { ProductObjClass } from "scrivito/Objs/Product/ProductObjClass"
import { ProductBaseVariantObj } from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"
import { getVariantKeyPrefixLength } from "shared/lib/variant-key/getVariantKeyPrefixLength"

import { getVariantKeyAttributes } from "entities/products/lib/getProductType"
import { isVariantKey } from "entities/products/lib/isVariantKey"

import { useVariantKey } from "./useVariantKey"

export function useProductObj(
  variantKey: string,
  options?: { returnHiddenProducts?: boolean }
) {
  const { productType, attributes } = useVariantKey(variantKey)
  const { returnHiddenProducts = true } = options || {}

  if (!isVariantKey(variantKey)) {
    return {
      productObj: null,
      productBaseVariantObj: null
    }
  }

  const productObj = ProductObjClass.where(
    "productType",
    "equals",
    productType
  ).first()

  if (!returnHiddenProducts && productObj?.get("isHiddenInPortfolio")) {
    return {
      productObj: null,
      productBaseVariantObj: null
    }
  }

  const productBaseVariantObj =
    productObj
      ?.children()
      .map(child => ({
        child: child as ProductBaseVariantObj,
        prefixLength: getVariantKeyPrefixLength(
          getVariantKeyAttributes(child.get("variantKey") as string),
          attributes,
          true
        )
      }))
      .filter(child => child.prefixLength !== -1)
      .sort((a, b) => (a.prefixLength > b.prefixLength ? -1 : 1))
      .map(p => p.child)[0] || null

  return {
    productObj,
    productBaseVariantObj
  }
}
